module.exports = "/static/assets/f887517952a8ff3802c2b6e52ecf32d3.svg";